<div class="row ddc-select-structure-div">
  <mat-form-field floatLabel="always" class="col col-md-5">
    <mat-label>Sélectionner une structure</mat-label>
    <mat-select [compareWith]="compareObjects" [(value)]="_ddcDefaultStructure" (selectionChange)="changeSelectedStructure($event)">
      <mat-option *ngFor="let ddcStructure of _ddcStructures" [value]="ddcStructure">
        {{ddcStructure.code}} - {{ddcStructure.libelle}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <section *ngIf="isStructureDependanteCheckbox" class="col">
    <mat-checkbox [checked]="structureDependanteCheckboxBool" (change)="structureDependanteCheckbox($event.checked)">Structures dépendantes</mat-checkbox>
  </section>
</div>

<div class="row">
  <div class="offset-3 col-md-9">
    <div ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.description" class="ddc-appli-description"></div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="ddc-table-div-container mat-elevation-z4">
      <table mat-table matSort [dataSource]="adherentsDisponiblesTableDataSource">
        <ng-container matColumnDef="prenomNom">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherent.prenomNom"></span>
          </th>
          <td mat-cell *matCellDef="let adherent"> {{adherent.prenom}}  {{adherent.nom}} </td>
        </ng-container>

        <ng-container matColumnDef="ajouter">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let adherent; let i = index;">
            <button
              mat-flat-button class="ddc-button-primary"
              (click)="ajouterAdherentsDisponiblesSelectionnes(i)"
              [disabled]="_isSaving">
              <i class="material-icons">add_circle</i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="adherentsDisponiblesTableDisplayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: adherentsDisponiblesTableDisplayedColumns;"></tr>
      </table>
    </div>
  </div>

  <div class="col-md-9">
    <div class="ddc-table-div-container mat-elevation-z4">
      <table mat-table [dataSource]="ddcStaffsTableDataSource">
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.roleStaff.libelleCourt"></span>
          </th>
          <td mat-cell *matCellDef="let control">
            <i *ngIf="getDdcAdherentStaffRoleIcon(control.get('roleStaff')?.value); let roleStaffIcon" class="material-icons">{{roleStaffIcon}}</i>
          </td>
        </ng-container>

        <ng-container matColumnDef="prenomNom">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.prenomNom"></span>
          </th>
          <td mat-cell *matCellDef="let control"> {{control.get('adherent').value.prenom}} {{control.get('adherent').value.nom}}</td>
        </ng-container>

        <ng-container *ngIf="_typeDossier === TypeDossierEnum.CAMP" matColumnDef="agePremierJourCamp">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.ageDebutCamp"></span>
          </th>
          <td mat-cell *matCellDef="let control">
            {{
            (control.get('adherent').value.numero && adherentsInformations[control.get('adherent').value.numero]) ?
              getAgeAdherentAuDebutCamp(this._currentCamp, adherentsInformations[control.get('adherent').value.numero].dateDeNaissance) : ''
            }}</td>
        </ng-container>

        <ng-container matColumnDef="techAppro">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.techAppro"></span>
          </th>
          <td mat-cell *matCellDef="let control">{{getTechApproLabel(control.get('adherent').value.numero)}}</td>
        </ng-container>

        <ng-container matColumnDef="qualif">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.qualifications.libelleCourt"></span>
          </th>
          <td mat-cell *matCellDef="let control">{{getAdherentQualificationLabel(control.get('adherent').value.numero, adherentsInformations)}}</td>
        </ng-container>

        <ng-container *ngIf="_typeDossier === TypeDossierEnum.CAMP" matColumnDef="resp">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.responsabilite.libelleCourt"></span>
          </th>
          <td mat-cell *matCellDef="let control">
            <i *ngIf="control.get('responsabiliteIntendant')?.value" class="material-icons">restaurant</i>
            <i *ngIf="control.get('responsabiliteTresorier')?.value" class="material-icons">local_atm</i>
            <i *ngIf="control.get('responsabiliteAS')?.value" class="material-icons">local_hospital</i>
            <i *ngIf="control.get('responsabiliteMateriel')?.value" class="material-icons">local_shipping</i>
            <i *ngIf="control.get('responsabiliteAutre')?.value" class="material-icons">more_horiz</i>
          </td>
        </ng-container>

        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.stage.libelleCourt"></span>
          </th>
          <td mat-cell *matCellDef="let control">
            <i *ngIf="control.get('validationStagePratiqueBafa')?.value" class="material-icons">A</i>
            <i *ngIf="control.get('validationStagePratiqueBafd')?.value" class="material-icons">D</i>
          </td>
        </ng-container>

        <ng-container *ngIf="_typeDossier === TypeDossierEnum.CAMP" matColumnDef="dateDebutPresence">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.dateDebutPresence.libelleCourt"></span>
          </th>
          <td mat-cell *matCellDef="let control"> {{convertToHumanDate(control.get('dateDebutPresence').value)}} </td>
        </ng-container>

        <ng-container *ngIf="_typeDossier === TypeDossierEnum.CAMP" matColumnDef="dateFinPresence">
          <th mat-header-cell *matHeaderCellDef>
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.dateFinPresence.libelleCourt"></span>
          </th>
          <td mat-cell *matCellDef="let control"> {{convertToHumanDate(control.get('dateFinPresence').value)}} </td>
        </ng-container>

        <ng-container matColumnDef="supprimer">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row;">
            <button
              mat-flat-button color="warn"
              (click)="supprimerDdcAdherentStaffSelectionne(row)"
              [disabled]="_isSaving">
              <i class="material-icons">remove_circle</i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="getDdcStaffsTableDisplayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: getDdcStaffsTableDisplayedColumns();"
            (click)="selectionnerDdcAdherentStaff(row)"
            [class.table-active]="row === ddcStaffSelectionneFormGroup"
            [class.table-danger]="row.invalid">
        </tr>
      </table>
    </div>
    <span class="ddc-warning-message" *ngIf="this.warningMessageDirecteur">
            <span><i class="material-icons">report_problem</i></span>&nbsp;
            <span>{{this.warningMessageDirecteur}}</span>
          </span>
  </div>
</div>

<div class="row">
  <div class="col-md-5">
    <div class="row">
      <mat-form-field floatLabel="always" class="col">
        <mat-label ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.ajouterAdherentParCode" class="link"></mat-label>
        <input matInput type="number" [formControl]="codeEntryForm.get('staff')">
        <mat-error *ngIf="codeEntryForm.get('staff').errors">
          {{codeEntryForm.get('staff').errors.errorMessage}}
        </mat-error>
        <mat-hint>Entrez 9 chiffres</mat-hint>
      </mat-form-field>

      <div class="col-auto ddc-textfield-btn-div">
        <button
          mat-raised-button
          [disabled]="disableCodeSubmitButton(codeEntryForm.get('staff'))"
          (click)="addStaffByCodeEntry(TypeAdherentEnum.STAFF)"
          class="ddc-button-primary">
          <i class="material-icons">add_circle</i>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="ddcStaffSelectionneFormGroup">
  <mat-card class="ddc-subcard-with-title">
    <mat-card-title>
      Maitrise : {{ddcStaffSelectionneFormGroup.get('adherent')?.value.prenom}}
      {{ddcStaffSelectionneFormGroup.get('adherent')?.value.nom}}
    </mat-card-title>
    <mat-card-content>
      <div ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.maitrise.description" class="ddc-appli-description link"></div>
      <div class="row">
        <div class="col-md-3">
          <div class="ddc-read-only-data-container">
            <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.numeroAdherent"></span>&nbsp;
            <span class="ddc-value">{{numeroAdherentSelectionne}}</span>
          </div>
        </div>

        <ng-container *ngIf="adherentsInformations[numeroAdherentSelectionne]">
          <div class="col-md-3">
            <div class="ddc-read-only-data-container">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.fonction"></span>&nbsp;
              <span class="ddc-value">{{adherentsInformations[numeroAdherentSelectionne].fonction}}</span>
            </div>
          </div>
          <div class="col-md-3 ddc-margin-auto">
            <div class="ddc-read-only-data-container">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.statut"></span>&nbsp;
              <span class="ddc-value">{{adherentsInformations[numeroAdherentSelectionne].statut}}</span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="ddc-read-only-data-container">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.telephone"></span>&nbsp;
              <span class="ddc-value">{{adherentsInformations[numeroAdherentSelectionne].telephonePortable1}}</span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="ddc-read-only-data-container">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.email"></span>&nbsp;
              <span class="ddc-value">{{adherentsInformations[numeroAdherentSelectionne].email}}</span>
            </div>
          </div>
          <div *ngIf="_typeDossier === TypeDossierEnum.CAMP" class="col-md-3">
            <div class="ddc-read-only-data-container">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.ageDebutCamp"></span>&nbsp;
              <span
                class="ddc-value">{{getAgeAdherentAuDebutCamp(this._currentCamp, adherentsInformations[numeroAdherentSelectionne].dateDeNaissance)}}</span>
            </div>
          </div>
        </ng-container>

      </div>
      <hr/>
      <div class="row">
        <mat-form-field floatLabel="always" class="col-md-4">
          <mat-label ddcLabel labelKey="bdd.campAdherentStaff.roleStaff"></mat-label>
          <mat-select [formControl]="ddcStaffSelectionneFormGroup.get('roleStaff')" required>
            <mat-option *ngFor="let ddcAdherentStaffRole of getDdcAdherentStaffAvailableRoles()"
                        [value]="ddcAdherentStaffRole.value">
              {{ddcAdherentStaffRole.text}}
            </mat-option>
          </mat-select>
          <mat-error ddcMatError [control]="ddcStaffSelectionneFormGroup.get('roleStaff')"></mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="_typeDossier === TypeDossierEnum.CAMP" floatLabel="always" class="col-md-4">
          <mat-label ddcLabel labelKey="bdd.campAdherentStaff.responsabilite"></mat-label>
          <mat-select multiple [value]="getDdcAdherentStaffResp()"
                      (selectionChange)="setDdcAdherentStaffResp($event)"
                      [disabled]="_compositionType == CompositionTypeEnum.VISITEUR">
            <mat-option *ngFor="let ddcAdherentStaffResponsibility of ddcAdherentStaffResponsibilities"
                        [value]="ddcAdherentStaffResponsibility.value">
              {{ddcAdherentStaffResponsibility.text}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="(_typeDossier && _typeDossier != TypeDossierEnum.CAMP)
                             || (_currentCamp && _currentCamp.typeCamp && _currentCamp.typeCamp.codeGroupeCamp != TypeCampGroupEnum.AUDACE)">
          <mat-form-field floatLabel="always" class="col-md-4">
            <mat-label ddcLabel labelKey="bdd.campAdherentStaff.stage"></mat-label>
            <mat-select [value]="getDdcAdherentStaffStage()"
                        (selectionChange)="setDdcAdherentStaffStage($event)">
              <mat-option *ngFor="let ddcAdherentStaffStage of ddcAdherentStaffStages"
                          [value]="ddcAdherentStaffStage.value">
                {{ddcAdherentStaffStage.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>

      <div class="row" *ngIf="_typeDossier === TypeDossierEnum.CAMP">
        <mat-form-field floatLabel="always" class="col-md-4">
          <mat-label ddcLabel labelKey="bdd.campAdherentStaff.dateDebutPresence"></mat-label>
          <input matInput [matDatepicker]="dateDebutPresenceDatepicker"
                 [formControl]="ddcStaffSelectionneFormGroup.get('dateDebutPresence')" required>
          <mat-datepicker-toggle matSuffix [for]="dateDebutPresenceDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #dateDebutPresenceDatepicker></mat-datepicker>
          <mat-error ddcMatError [control]="ddcStaffSelectionneFormGroup.get('dateDebutPresence')"></mat-error>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="col-md-4">
          <mat-label ddcLabel labelKey="bdd.campAdherentStaff.dateFinPresence"></mat-label>
          <input matInput [matDatepicker]="dateFinPresenceDatepicker"
                 [formControl]="ddcStaffSelectionneFormGroup.get('dateFinPresence')" required>
          <mat-datepicker-toggle matSuffix [for]="dateFinPresenceDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #dateFinPresenceDatepicker></mat-datepicker>
          <mat-error ddcMatError [control]="ddcStaffSelectionneFormGroup.get('dateFinPresence')"></mat-error>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="col-md-4">
          <mat-label ddcLabel labelKey="bdd.camp.commentaireAdherentStaff"></mat-label>
          <textarea type="text" matInput [formControl]="ddcStaffSelectionneFormGroup.get('commentaireAdherentStaff')"></textarea>
        </mat-form-field>
      </div>

      <ng-container *ngIf="adherentsInformations[numeroAdherentSelectionne]">
        <div class="row">
          <div class="col-md-12 ddc-adherent-info-title">
            <b><span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.formations.title"></span></b>
          </div>
        </div>
        <ng-container
          *ngIf="adherentsInformations[numeroAdherentSelectionne].adherentFormations &&
                adherentsInformations[numeroAdherentSelectionne].adherentFormations.length > 0; else noAdherentFormationsBlock">
          <div class="row">
            <div class="col-md-12">
              <table class="read-only-mat-table" mat-table [dataSource]="adherentsInformations[numeroAdherentSelectionne].adherentFormations">
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.formations.type"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentFormation"> {{adherentFormation.type}} </td>
                </ng-container>

                <ng-container matColumnDef="dateFin">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.formations.dateFin"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentFormation"> {{convertToHumanDate(adherentFormation.dateFin)}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="adherentFormationsTableDisplayedComumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: adherentFormationsTableDisplayedComumns;"></tr>
              </table>
            </div>
          </div>
        </ng-container>
        <ng-template #noAdherentFormationsBlock>
          <div class="row">
            <div class="col-md-12">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.formations.noFormations"></span>
              <hr/>
            </div>
          </div>
        </ng-template>

        <div class="row">
          <div class="col-md-12 ddc-adherent-info-title">
            <b><span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.diplomes.title"></span></b>
          </div>
        </div>
        <ng-container
          *ngIf="adherentsInformations[numeroAdherentSelectionne].adherentDiplomes && adherentsInformations[numeroAdherentSelectionne].adherentDiplomes.length > 0; else noAdherentDiplomesBlock">
          <div class="row">
            <div class="col-md-12">
              <table class="read-only-mat-table" mat-table [dataSource]="adherentsInformations[numeroAdherentSelectionne].adherentDiplomes">
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.diplomes.type"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentDiplome"> {{adherentDiplome.type}} </td>
                </ng-container>

                <ng-container matColumnDef="dateObtention">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.diplomes.dateObtenation"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentDiplome"> {{convertToHumanDate(adherentDiplome.dateObtention)}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="adherentDiplomesTableDisplayedComumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: adherentDiplomesTableDisplayedComumns;"></tr>
              </table>
            </div>
          </div>
        </ng-container>
        <ng-template #noAdherentDiplomesBlock>
          <div class="row">
            <div class="col-md-12">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.diplomes.noDiplomes"></span>
              <hr/>
            </div>
          </div>
        </ng-template>

        <div class="row">
          <div class="col-md-12 ddc-adherent-info-title">
            <b><span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.qualifications.title"></span></b>
          </div>
        </div>
        <ng-container
          *ngIf="adherentsInformations[numeroAdherentSelectionne].adherentQualifications && adherentsInformations[numeroAdherentSelectionne].adherentQualifications.length > 0; else noAdherentQualificationsBlock">
          <div class="row">
            <div class="col-md-12">
              <table class="read-only-mat-table" mat-table [dataSource]="adherentsInformations[numeroAdherentSelectionne].adherentQualifications">
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.qualifications.type"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentQualification"> {{adherentQualification.type}} </td>
                </ng-container>

                <ng-container matColumnDef="estTitulaire">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.qualifications.titulaire"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentQualification"> {{adherentQualification.estTitulaire === true ? 'Oui' : 'Non'}} </td>
                </ng-container>

                <ng-container matColumnDef="dateFin">
                  <th mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.qualifications.dateFin"></span>
                  </th>
                  <td mat-cell *matCellDef="let adherentQualification"> {{convertToHumanDate(adherentQualification.dateFin)}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="adherentQualificationsTableDisplayedComumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: adherentQualificationsTableDisplayedComumns;"></tr>
              </table>
            </div>
          </div>
        </ng-container>
        <ng-template #noAdherentQualificationsBlock>
          <div class="row">
            <div class="col-md-12">
              <span ddcLabel labelKey="appli.shared.staffSelector.adherentStaff.adherentInformations.qualifications.noQualifications"></span>
              <hr/>
            </div>
          </div>
        </ng-template>

      </ng-container>

    </mat-card-content>
  </mat-card>
</div>
